import UserService from "@/services/UserService";
import { bool } from "yup";
//this.$store.state.user.users,current_page
export const user = {
    namespace:true,
    state: {users:{},fail:bool,searchNotification:0,paramether:[] },
    actions: {
        async getListUser({commit},pageNumber){
            return await UserService.getlist(pageNumber).then(
                response=>{    
                    commit('setUsers',response);                    
                },
                error => {
                    commit('setFailure');
                    return Promise.reject(error);
                })
        },
        async searchListUser({commit},search){          
            return await UserService.getSearch(search).then (
                response =>{                    
                    commit('setUsers',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure')
                    return Promise.reject(error)
                }
            );
        },
        
    },
  mutations: {
    setUsers(state,data){
        state.users = data
    },
    setFailure(state){
        state.fail = false
    },
    setCurrentPage(state,data){
        state.users.current_page = data
    },
    setSearchNotify(state,data){        
        state.searchNotification = data
    },
    setParamether(state,paramSearch){        
        state.paramether = paramSearch
    }
  }
};